module.exports = __webpack_public_path__ + "img/1 (32).525f13f7.png";